module.exports = __webpack_public_path__ + "static/media/160x600.9ed9a9f1.png";